import { render } from "./OrderInfoField.vue?vue&type=template&id=39c20ac2&scoped=true"
import script from "./OrderInfoField.vue?vue&type=script&lang=js"
export * from "./OrderInfoField.vue?vue&type=script&lang=js"

import "./OrderInfoField.vue?vue&type=style&index=0&id=39c20ac2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c20ac2"]])

export default __exports__